import Config from "config";
import parse from "html-react-parser";
import React from "react";
import {
  addCommas,
  dmyHmsToDateObj,
  getArea,
  getDateTimeFormat,
  getPropertyType,
  showAreaValue,
  showBedAndBath,
  showUseableAreaValue,
  timeInRangeList,
} from "../common/Common";
import { prepareDataForProopertyBox } from "../common/PropertyBox";
import "./index.css";

const pagesLink = Config.pagesLink;

import { auctionDetailLink } from "./auctionConstants";

export const TagBadgeWrapper = React.memo((propertyDetail) => {
  // console.log("TagBadgeWrapper Render");

  return (
    <div className="badge-wrapper">
      {propertyDetail.IsPartner && (
        <div className="gallery-badge partner-badege">
          <i className="ic-npa ic-npa-icon-partnershipbadge"></i>
          <p>ทรัพย์ผู้ขาย</p>
        </div>
      )}
      {propertyDetail.PropertyID.slice(2, 4) === "66" && (
        <div className="gallery-badge wait-for-sale-badege">
          <i className="ic-npa ic-npa-icon-propertywaitsale-badge"></i>
          <p>ทรัพย์ฝากขาย</p>
        </div>
      )}
      {propertyDetail.IsNew && (
        <div className="gallery-badge new">
          <i className="ic-npa ic-npa-icon-new-badge"></i>
          <p>NEW</p>
        </div>
      )}
      {propertyDetail.IsHot && (
        <div className="gallery-badge hot">
          <i className="ic-npa ic-npa-icon-hot-badge"></i>
          <p>HOT</p>
        </div>
      )}
      {propertyDetail.PromotionName && (
        <div className="gallery-badge promo">
          <i className="ic-npa ic-npa-icon-promotion-badge"></i>
          <p>PROMOTION</p>
        </div>
      )}
    </div>
  );
});

export const PartnerDetail = React.memo((propertyDetail) => {
  // console.log("TagBadgeWrapper Render");
  if (!propertyDetail.IsPartner) return;
  return (
    <div className="npa-wrapper-partner-detail">
      <span>ทรัพย์ผู้ขาย :</span>
      <div>
        <img
          src={
            "/SiteCollectionDocuments/assets/PFS2022/theme/img/logo/" +
            propertyDetail.SourceImageLogo
          }
          alt="Logo Partner"
        />
      </div>
    </div>
  );
});

export const PriceWrapper = React.memo((props) => {
  //  Price
  let tag = "";
  let PromotionPrice = "";
  let Price = "";
  if (props.PromotionPrice) {
    if (props.isAuction) {
      tag = <div className="special-badge">ราคาประมูลเริ่มต้นที่</div>;
    } else {
      tag = <div className="special-badge">ราคาพิเศษ</div>;
    }

    PromotionPrice = (
      <h2 className="special-price">
        {addCommas(props.PromotionPrice)}
        <span>บาท</span>
      </h2>
    );
    Price = <p className="old-price">{addCommas(props.SellPrice)} บาท</p>;
  } else if (props.AdjustPrice) {
    tag = <div className="lower-badge">ราคาลดลงกว่าเดิม</div>;
    PromotionPrice = (
      <h2 className="special-price c-black">
        {addCommas(props.AdjustPrice)}
        <span>บาท</span>
      </h2>
    );
    Price = <p className="old-price">{addCommas(props.SellPrice)} บาท</p>;
  } else {
    tag = <div></div>;
    PromotionPrice = (
      <h2 className="special-price c-black">
        {addCommas(props.SellPrice)}
        <span>บาท</span>
      </h2>
    );
  }

  console.log("PriceWrapper Render");

  return (
    <div className="price-wrapper">
      {tag}
      <div className="price-inner-l">
        {PromotionPrice}
        {Price}
      </div>
    </div>
  );
});

export const PropertyDetailsTable = React.memo((propertyDetail) => {
  console.log("render PropertyDetailsTable");

  var area = showAreaValue(propertyDetail) ? getArea(propertyDetail) : "";

  area = area ? area.value + " " + area.unit : "";

  return (
    <div className="property-table">
      {propertyDetail.PropertyTypeName && (
        <div className="property-row">
          <div className="property-td first">ประเภททรัพย์</div>
          <div className="property-td second">{getPropertyType(propertyDetail)}</div>
        </div>
      )}
      {propertyDetail.AssetInfoTH && (
        <div className="property-row inverse">
          <div className="property-td first">
            รายละเอียด<span style={{ whiteSpace: "nowrap" }}>ของทรัพย์</span>
          </div>
          <div className="property-td second">{propertyDetail.AssetInfoTH}</div>
        </div>
      )}
      {area && (
        <div className="property-row">
          <div className="property-td first">ขนาดพื้นที่</div>
          <div className="property-td second">{area}</div>
        </div>
      )}
    </div>
  );
});

export const PropertyDetailsCondition = React.memo((propertyDetail) => {
  console.log("render PropertyDetailsCondition");

  const PMMaintenanceStatus =
    propertyDetail.PMMaintenanceStatus === "มีผู้บุกรุก"
      ? "มีผู้ใช้ประโยชน์"
      : propertyDetail.PMMaintenanceStatus;
  var propertySourceName = "";
  if (propertyDetail.PropertySourceID) {
    switch (propertyDetail.PropertySourceID) {
      case "13":
      case "03":
      case "04":
        propertySourceName = "โอนกรรมสิทธิ์เป็นของธนาคารแล้ว";
        break;
      case "12":
      case "02":
        propertySourceName = "อยู่ระหว่างโอนกรรมสิทธิ์เป็นของธนาคาร";
        break;
      case "66":
        propertySourceName = "ทรัพย์ฝากขาย ไม่ใช่ทรัพย์สินของธนาคาร"; //"<span class='c-red'>ทรัพย์ฝากขาย ไม่ใช่ทรัพย์สินของธนาคาร</span>";
        break;
      // case "10":
      //     propertySourceName = "ทรัพย์พาร์ทเนอร์ ไม่ใช่ทรัพย์สินของธนาคาร";
      //     break;
      default:
        propertySourceName = propertyDetail.PropertySourceName;
        break;
    }
  }

  var InOutProblemTH = "";

  if (propertyDetail.InOutProblemTH) {
    InOutProblemTH = "ทรัพย์มีข้อจำกัดทางเข้า-ออก";
  }

  function genList(value) {
    return (
      <li>
        <i className="ic-npa ic-npa-icon-check"></i>
        {value}
      </li>
    );
  }

  return (
    <div className="property-condition">
      {/* <div className="property-title"> */}
      <h2>เงื่อนไข / โปรโมชัน</h2>
      {/* </div> */}
      <ul className="listitem">
        {PMMaintenanceStatus && genList(PMMaintenanceStatus)}
        {propertySourceName && genList(propertySourceName)}
        {InOutProblemTH && genList(InOutProblemTH)}
        {propertyDetail.PromotionRemark && genList(propertyDetail.PromotionRemark)}
      </ul>
    </div>
  );
});

export const PropertyInfoTable = React.memo((propertyDetail) => {
  console.log("render PropertyInfoTable");

  var coordinateHtmls;

  if (
    propertyDetail.Latitude &&
    propertyDetail.Latitude !== "-" &&
    propertyDetail.Longtitude &&
    propertyDetail.Longtitude !== "-"
  ) {
    coordinateHtmls = (
      <>
        ละติจูด: {propertyDetail.Latitude} <br /> ลองติจูด: {propertyDetail.Longtitude}
      </>
    );
  } else if (propertyDetail.Latitude && propertyDetail.Latitude !== "-") {
    coordinateHtmls = <>ละติจูด: {propertyDetail.Latitude}</>;
  } else if (propertyDetail.Longtitude && propertyDetail.Longtitude !== "-") {
    coordinateHtmls = <>ลองติจูด: {propertyDetail.Longtitude}</>;
  }

  return (
    <>
      <div className="property-table">
        {propertyDetail.PropertyDocumentName && (
          <div className="property-row">
            <div className="property-td">
              ประเภท<span style={{ whiteSpace: "nowrap" }}>เอกสารสิทธิ์</span>
            </div>
            <div className="property-td">{propertyDetail.PropertyDocumentName}</div>
          </div>
        )}
        {propertyDetail.DocumentNo && (
          <div className="property-row">
            <div className="property-td">
              เลขที่<span style={{ whiteSpace: "nowrap" }}>เอกสารสิทธิ์</span>
            </div>
            <div className="property-td">{propertyDetail.DocumentNo}</div>
          </div>
        )}
        {coordinateHtmls && (
          <div className="property-row">
            <div className="property-td">พิกัดภูมิศาสตร์</div>
            <div className="property-td">{coordinateHtmls}</div>
          </div>
        )}
      </div>
      <SpecialAnnouncement {...propertyDetail} />
      {/* <div className="qrcode-container">
                <h3>QR Code ของทรัพย์สิน</h3>
                <QRCode size={200} value={window.location.href} />
            </div> */}
    </>
  );
});

const SpecialAnnouncement = React.memo((propertyDetail) => {
  // "838800093"
  if (propertyDetail.PropertyID == "028811523") {
    return (
      <>
        <div className="qrcode-container">
          <span>เงื่อนไขพิเศษ : </span>
          <span style={{ color: "red" }}>
            ราคาประกาศขายขั้นต่ำ 58,000,000.-บาท โดยผู้สนใจซื้อ ต้องทำการเสนอราคา ภายใน วันที่ 27
            เมษายน 2566 ถึง วันที่ 8 พฤษภาคม 2566 เวลา 12.00 น. ผู้เสนอราคาสูงสุดจะเป็นผู้ที่ได้รับ
            การพิจารณาจากทางธนาคาร เงื่อนไขอื่นๆ เป็นไปตามที่ธนาคารกำหนด.
          </span>
        </div>
      </>
    );
  }
  return;
});

export const AnnouncementText = React.memo((propertyDetail) => {
  try {
    var promoStart = dmyHmsToDateObj(propertyDetail.PromotionStartDate);
    var promoEnd = dmyHmsToDateObj(propertyDetail.PromotionEndDate);

    if (!timeInRangeList([[promoStart, promoEnd]], new Date().setHours(0, 0, 0, 0))) {
      return;
    }

    if (propertyDetail.isAuction) {
      console.log("acution true-->");
      return (
        <>
          <div className="announcement-wrapper">
            <div className="aw-ic">
              <i></i>
            </div>
            <div className="aw-text">
              <div className="aw-text-head">
                ทรัพย์ประมูล วันที่ {getDateTimeFormat(propertyDetail.isAuction[1], false)}
              </div>
              <div className="aw-text-desc"></div>
              <a href={auctionDetailLink}>ดูรายละเอียดเพิ่มเติม</a>
            </div>
          </div>
        </>
      );
    }

    var text = "ทรัพย์โปรโมชัน";

    if(propertyDetail.PromotionName.includes("0_fee_3yrs")){
      text += " โปรน็อกแรง ดอกเบี้ย 0% นาน 3 ปี";
    }else if(propertyDetail.PromotionName.includes("0_fee_10yrs")){
      text += " โปรน็อกแรง ดอกเบี้ย 0% นาน 10 ปี";
    }else{
      text += "ราคาพิเศษ";
    }
    
    return (
      <>
        <div className="announcement-wrapper">
          <div className="aw-ic">
            <i></i>
          </div>
          <div className="aw-text">
            <div className="aw-text-head">{text}</div>
            <div className="aw-text-desc">
              ตั้งแต่วันที่ {getDateTimeFormat(promoStart, false)} –{" "}
              {getDateTimeFormat(promoEnd, false)}
            </div>
          </div>
        </div>
      </>
    );
  } catch {
    return;
  }
});

export const PropertyRemark = React.memo((propertyDetail) => {
  console.log("render remark");

  var remarkHtml;

  if (propertyDetail.RemarkDetail) {
    remarkHtml = <>{parse(propertyDetail.RemarkDetail)}</>;
  } else if (propertyDetail.PropertyID) {
    var code = propertyDetail.PropertyID.substr(2, 2);

    if (propertyDetail.IsPartner) {
      remarkHtml = (
        <>
          <li>
            ข้อมูล ราคา และเงื่อนไขทรัพย์สินที่เสนอขาย
            อาจเปลี่ยนแปลงได้โดยผู้ขายไม่ต้องแจ้งให้ผู้ซื้อทราบล่วงหน้า
          </li>
          <li>
            ผู้ซื้อมีหน้าที่ต้องตรวจสอบข้อมูล สภาพทรัพย์สิน สถานที่ตั้งทรัพย์สิน
            และข้อมูลอื่นใดที่เกี่ยวข้องกับทรัพย์สินก่อนเสนอซื้อ
          </li>
        </>
      );
    } else if (code == "66") {
      remarkHtml = (
        <>
          <li>ทรัพย์ฝากขายเป็นทรัพย์สินของบุคคลภายนอก ธนาคารไม่ได้เป็นเจ้าของกรรมสิทธิ์</li>
          <li>ข้อมูลดังกล่าวเป็นข้อมูลของผู้ฝากขาย ธนาคารไม่รับรองความถูกต้องแต่อย่างใด</li>
          <li>ธนาคารไม่มีส่วนเกี่ยวข้องกับการตกลงซื้อขายและกำหนดเงื่อนไขใดๆ</li>
          <li>ข้อมูลทรัพย์สิน, ราคา, เงื่อนไข อาจมีการเปลี่ยนแปลงโดยไม่มีการแจ้งให้ทราบล่วงหน้า</li>
          <li>
            ค่าพิกัดภูมิศาสตร์และการตีเส้นสีแดงในภาพข้างต้น
            เป็นเพียงการระบุตำแหน่งที่ตั้งและประมาณการพื้นที่เบื้องต้นของทรัพย์สินรอการขายเบื้องต้นของธนาคารเท่านั้น
            ซึ่งอาจมีการคลาดเคลื่อนจากสภาพความเป็นจริงได้
            ผู้ซื้อต้องตรวจสอบสภาพสถานที่ตั้งทรัพย์สินด้วยตนเองก่อนซื้อ
          </li>
          <li>สำหรับทรัพย์ฝากขายทุกประเภท ไม่เข้าร่วมโปรโมชันฟรีค่าธรรมเนียมการโอนทุกกรณี</li>
          <li>
            ทรัพย์ฝากขายทุกประเภทที่<b>ไม่ติดจำนองกับธนาคารกสิกรไทย</b>
            ไม่สามารถเข้าร่วม แคมเปญสินเชื่อบ้าน โครงการ K-Smart Asset (Home Loan)
            และโครงการสินเชื่อเพื่อลงทุนในสินทรัพย์ถาวร (K-SME Smart Asset) ได้
          </li>
        </>
      );
    } else if (code == "88") {
      remarkHtml = (
        <>
          <li>ข้อมูลทรัพย์สิน, ราคา, เงื่อนไข อาจมีการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</li>
          <li>
            ค่าพิกัดภูมิศาสตร์เป็นเพียงการระบุตำแหน่งที่ตั้งทรัพย์สินรอการขายเบื้องต้นของธนาคารเท่านั้น
            อาจมีการคลาดเคลื่อนจากสภาพความเป็นจริงได้
            ผู้ซื้อต้องตรวจสอบสภาพสถานที่ตั้งทรัพย์สินด้วยตนเองก่อนซื้อ
          </li>
          <li>
            หากทรัพย์สินมีผู้บุกรุกและ/หรือผู้อยู่อาศัย และ/หรือการรอนสิทธิ์
            ผู้เสนอซื้อตกลงรับภาระในการดำเนินการเอง เว้นแต่จะตกลงไว้เป็นอย่างอื่น
          </li>
          <li>
            โปรโมชันฟรีค่าธรรมเนียมการโอนกรรมสิทธิ์
            สำหรับผู้ซื้อทรัพย์มือสองของธนาคารกสิกรไทยที่เป็นทรัพย์พร้อมโอน
            (โอนเป็นกรรมสิทธิ์ของธนาคารแล้ว) โดยธนาคารจ่ายค่าโอนกรรมสิทธิ์ให้ตามจริง ไม่เกิน 200,000
            บาท โดยมีเงื่อนไขดังนี้ สำหรับลูกค้าที่เสนอซื้อและได้รับการอนุมัติขาย ตั้งแต่วันที่ 1 เมษายน 2568
             - 31 กรกฎาคม 2568 ต้องดำเนินการโอนกรรมสิทธิ์ให้แล้วเสร็จภายใน 30 วัน
            นับจากวันที่ธนาคารแจ้งผลการอนุมัติขาย
          </li>
          <li>สำหรับทรัพย์ฝากขายทุกประเภท ไม่เข้าร่วมโปรโมชันฟรีค่าธรรมเนียมการโอนทุกกรณี</li>
          <li>
            สำหรับทรัพย์ที่มีราคาพิเศษที่ประกาศอยู่บนเว็บไซต์
            ธนาคารขอสงวนสิทธิ์อนุมัติขายให้กับลูกค้าที่ทำการเสนอซื้อไม่ต่ำกว่าราคาพิเศษ
            และวางเงินประกันการเสนอซื้อ 1% พร้อมส่งเอกสารหลักฐานการเสนอซื้อเป็นลำดับแรก
          </li>
          <li>เงื่อนไขการขอคืนเงินประกัน/เงินมัดจำ</li>
          <li>
            กรณียื่นสินเชื่อกับธนาคารกสิกรไทยเท่านั้น ถึงจะสามารถขอเงินคืนได้โดยมีเงื่อนไขดังนี้ :
            <ul style={{ listStyle: "- " }}>
              <li>ธนาคารไม่อนุมัติสินเชื่อ หรือ</li>
              <li>
                ธนาคารอนุมัติสินเชื่อ แต่ไม่เท่ากับจำนวนที่ท่านยื่นเรื่องขอสินเชื่อไว้ (ต่างเสนอ)
              </li>
              <li>
                ลูกค้าต้องยื่นขอสินเชื่อกับธนาคารกสิกรไทยเท่านั้น โดยระยะเวลาที่ยื่นไม่เกิน 15 วัน
                หลังวันที่ธนาคารแจ้งผลการอนุมัติขายทรัพย์
              </li>
              <li>
                ลูกค้าต้องเซ็นสัญญาซื้อขายและวางเงินมัดจำเพิ่ม 9% ไม่เกิน 15 วัน
                หลังวันที่ธนาคารแจ้งผลการอนุมัติขายทรัพย์
              </li>
              <li>
                โดยลูกค้าสามารถติดต่อทีมขายที่ดูแลสินเชื่อ เพื่อทำเรื่องเสนอขอคืนเงินประกัน (1%)
                ธนาคารขอสงวนสิทธิ์ที่จะเปลี่ยนแปลงเงื่อนไขต่างๆ รวมถึงข้อกำหนดและการยกเลิกรายการส่งเสริมการขายนี้ 
                โดยธนาคารจะแจ้งให้ทราบล่วงหน้าผ่านช่องทาง K-Contact Center{' '}
                <a href="tel:028888888" className="tel-link">
                  02-8888888
                </a>{" "}
                ในกรณีพิพาทคำตัดสินของธนาคารถือเป็นที่สิ้นสุด
              </li>
            </ul>
          </li>
        </>
      );
    } else {
      remarkHtml = (
        <>
          <li>ข้อมูลทรัพย์สิน, ราคา, เงื่อนไข อาจมีการเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</li>
          <li>
            ค่าพิกัดภูมิศาสตร์และการตีเส้นสีแดงในภาพข้างต้น
            เป็นเพียงการระบุตำแหน่งที่ตั้งและประมาณการพื้นที่เบื้องต้นของทรัพย์สินรอการขายเบื้องต้นของธนาคารเท่านั้น
            ซึ่งอาจมีการคลาดเคลื่อนจากสภาพความเป็นจริงได้
            ผู้ซื้อต้องตรวจสอบสภาพสถานที่ตั้งทรัพย์สินด้วยตนเองก่อนซื้อ
          </li>
          <li>
            หากทรัพย์สินมีผู้บุกรุกและ/หรือผู้อยู่อาศัย และ/หรือการรอนสิทธิ์
            ผู้เสนอซื้อตกลงรับภาระในการดำเนินการเอง เว้นแต่จะตกลงไว้เป็นอย่างอื่น
          </li>
          <li>
            สำหรับทรัพย์ที่มีราคาพิเศษประกาศอยู่บนเว็บไซต์ ธนาคารขอสงวนสิทธิ อนุมัติขายให้กับ
            ลูกค้าที่ทำการเสนอซื้อไม่ต่ำกว่าราคาพิเศษ และวางเงินประกันการเสนอซื้อ 1%
            พร้อมส่งเอกสารหลักฐานการเสนอซื้อ เป็นลำดับแรก
          </li>
          <li>
            ธนาคารขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไข ข้อกำหนด
            รวมถึงการยกเลิกรายการส่งเสริมการขายนี้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า หลักเกณฑ์
            และเงื่อนไขอื่นๆ เป็นไปตามที่ธนาคารกำหนด
            ในกรณีมีข้อพิพาทให้ถือคำตัดสินของธนาคารเป็นที่สุด สอบถามข้อมูลเพิ่มเติม K-Contact Center
            โทร{" "}
            <a href="tel:028888888" className="tel-link">
              02-8888888
            </a>{" "}
            กด 04
          </li>
        </>
      );
    }
  }

  return (
    <>
      <div className="mark-wrapper">
        <div className="mark-header">หมายเหตุ :</div>
        <ul className="mark-body">{remarkHtml}</ul>
        <div className="mark-more" data-kbct="accordion_content">
          <span data-kblb="detail-more_detail" data-kbgp="detail" data-kbsc="detail">เพิ่มเติม</span>
          <i className="ic-npa ic-npa-icon-arrow" />
        </div>
      </div>
    </>
  );
});

function areEqual(prevProps, nextProps) {
  if (prevProps !== nextProps) {
    return false;
  }
  return true;
}

export const PropertyNearByTabList = React.memo((propertyDetail) => {
  const NearbyPlaces = propertyDetail.NearbyPlaces;

  let tab = [];
  let tabDetail = [];
  let lg = propertyDetail.addtion;

  if (NearbyPlaces) {
    NearbyPlaces.map((item, index) => {
      let id = "";
      if (typeof item.TypeCode !== "string") {
        id = item.TypeCode[0];
      } else {
        id = item.TypeCode;
      }

      let icon = "";

      if (item.icon) {
        icon = item.icon;
      }

      tab.push(
        <li className="nav-item" role="tab" key={"tabNearBy-" + id}>
          <a
            href="javascript:void(0)"
            className={`nav-link ${index === 0 ? "active" : ""}`}
            data-bs-target={`#${id + lg}`}
            data-bs-toggle="pill"
            aria-selected="true"
          >
            <i className={`ic-npa ic-npa-icon-${icon}`}></i>
          </a>
        </li>
      );

      tabDetail.push(
        <div
          id={`${id + lg}`}
          className={`tab-pane fade show ${index === 0 ? "active" : ""}`}
          role="tabpanel"
          key={"tabNearByDetail-" + id}
        >
          <h3>{item.NameTH}</h3>
          <ul className="list-menu">
            {item.places.slice(0, 10).map((item, index) => {
              return (
                <li key={item["PlaceName"] + lg}>
                  {item.PlaceName} {(item.Distance / 1000).toFixed(1)} กม.
                </li>
              );
            })}
          </ul>
        </div>
      );
      // console.log(item, index, id, tab, tabDetail)
    });
  }

  console.log("PropertyNearByTabList render", NearbyPlaces);
  // locations = locations.map(({places}) => places).flat()
  // propertyDetail.addtion  (-lg)
  return (
    <>
      <div className="tab-facility">
        <ul className="nav" role="tablist">
          {tab}
          {/* <li className="nav-item" role="tab">
                      <a href={void (0)} className="nav-link active" data-bs-target="#skytrain-lg" data-bs-toggle="pill" aria-selected="true">
                          <i className="ic-npa ic-npa-icon-skytrain"></i>
                      </a>
                  </li>
                  <li className="nav-item" role="tab">
                      <a href={void (0)} className="nav-link" data-bs-target="#shopping-lg" data-bs-toggle="pill" aria-selected="false">
                          <i className="ic-npa ic-npa-icon-shopping"></i>
                      </a>
                  </li>
                  <li className="nav-item" role="tab">
                      <a href={void (0)} className="nav-link" data-bs-target="#hospital-lg" data-bs-toggle="pill" aria-selected="false">
                          <i className="ic-npa ic-npa-icon-hospital"></i>
                      </a>
                  </li>
                  <li className="nav-item" role="tab">
                      <a href={void (0)} className="nav-link" data-bs-target="#restaurant-lg" data-bs-toggle="pill" aria-selected="false">
                          <i className="ic-npa ic-npa-icon-restaurant"></i>
                      </a>
                  </li> */}
        </ul>
      </div>

      <div className="tab-content tab-facility-content">
        {tabDetail}
        {/* <div id="skytrain-lg" className="tab-pane fade show active" role="tabpanel">
                  <h3>รถไฟฟ้า</h3>
                  <ul className="list-menu">
                      <li>ศูนย์ราชการนนทบุรี 0.8 กม.</li>
                      <li>กระทรวงสาธารณสุข 1.1 กม.</li>
                      <li>บางกระสอ 1.7 กม.</li>
                  </ul>
              </div>
              <div id="shopping-lg" className="tab-pane fade" role="tabpanel">
                  <h3>Shopping</h3>
                  <ul className="list-menu">
                      <li>ศูนย์ราชการนนทบุรี 0.8 กม.</li>
                      <li>กระทรวงสาธารณสุข 1.1 กม.</li>
                      <li>บางกระสอ 1.7 กม.</li>
                  </ul>
              </div>
              <div id="hospital-lg" className="tab-pane fade" role="tabpanel">
                  <h3>Hospital</h3>
                  <ul className="list-menu">
                      <li>ศูนย์ราชการนนทบุรี 0.8 กม.</li>
                      <li>กระทรวงสาธารณสุข 1.1 กม.</li>
                      <li>บางกระสอ 1.7 กม.</li>
                  </ul>
              </div>
              <div id="restaurant-lg" className="tab-pane fade" role="tabpanel">
                  <h3>Restaurant</h3>
                  <ul className="list-menu">
                      <li>ศูนย์ราชการนนทบุรี 0.8 กม.</li>
                      <li>กระทรวงสาธารณสุข 1.1 กม.</li>
                      <li>บางกระสอ 1.7 กม.</li>
                  </ul>
              </div> */}
      </div>
    </>
  );
}, areNearbyPlacesEqual);

export const PropertyNearByTabList2024 = React.memo((propertyDetail) => {
  const NearbyPlaces = propertyDetail.NearbyPlaces;

  let tab = [];
  let tabDetail = [];
  let lg = propertyDetail.addtion;

  const CategoryDetail = propertyDetail.CategoryDetail;

  var hasFirstTab = false;

  if (CategoryDetail) {
    const details = CategoryDetail.split("#").filter((detail) => detail !== "");
    const data = [];

    details.forEach((detail) => {
      const [PlaceName, Distance] = detail.split("|");
      data.push({ PlaceName, Distance });
    });
    tabDetail.push(
      <div key={"CategoryDetail"} className={`g-content active`}>
        <table>
          <tbody>
            {data.map((item, index) => {
              return (
                <tr key={item["PlaceName"] + lg + index}>
                  <td>
                    <span className="list">{item.PlaceName}</span>
                  </td>
                  <td>{parseFloat(item.Distance).toFixed(1)} กม.</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
    hasFirstTab = tabDetail.length > 0;

    if (hasFirstTab) {
      tab.push(
        <li className={`g-tab-list active`} role="tab" key={"interestingPoint"}>
          <span>จุดน่าสนใจ</span>
        </li>
      );
    }
  }

  if (NearbyPlaces) {
    NearbyPlaces.map((item, index) => {
      let id = "";
      if (typeof item.TypeCode !== "string") {
        id = item.TypeCode[0];
      } else {
        id = item.TypeCode;
      }

      let icon = "";

      if (item.icon) {
        icon = item.icon;
      }

      tab.push(
        <li
          className={`g-tab-list ${index === 0 && !hasFirstTab ? "active" : ""}`}
          role="tab"
          key={"tabNearBy-" + id}
          data-kbct="click" data-kblb="nearby" data-kbgp="nearby" data-kbsc="detail" 
        >
          <span>{item.NameTH}</span>
        </li>
      );

      tabDetail.push(
        <>
          <div
            key={"tabNearByDetail-" + id}
            className={`g-content ${index === 0 && !hasFirstTab ? "active" : ""}`}
          >
            <table>
              <tbody>
                {item.places.slice(0, 10).map((item, index) => {
                  return (
                    <tr key={item["PlaceName"] + lg + index}>
                      <td>
                        <span className="list">{item.PlaceName}</span>
                      </td>
                      <td>{(parseFloat(item.Distance) / 1000).toFixed(1)} กม.</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      );
      // console.log(item, index, id, tab, tabDetail)
    });
  }

  console.log("PropertyNearByTabList render", NearbyPlaces);
  // locations = locations.map(({places}) => places).flat()
  // propertyDetail.addtion  (-lg)
  return (
    <>
      <div className="place-nearby">
        <h2>สถานที่ใกล้เคียง</h2>
        <div id="tab-1" className="g-tab-toggle-content">
          <div className="g-tab-toggle-inner">
            <div className="g-tab-toggle">
              <ul className="g-tab-wrapper">{tab}</ul>
            </div>
            <button type="button" className="g-tab-button">
              <i className="g-tab-arrow" />
            </button>
            <div className="g-float"></div>
          </div>
          <div className="g-tab-content">{tabDetail}</div>
        </div>
      </div>
    </>
  );
}, areNearbyPlacesEqual);

function areNearbyPlacesEqual(prevProps, nextProps) {
  if (prevProps.NearbyPlaces?.length !== nextProps.NearbyPlaces?.length) {
    return false;
  }
  return true;
}

export const DetailContainer = React.memo((propertyDetail) => {
  var Bedroom =
    showBedAndBath(propertyDetail) && propertyDetail.Bedroom > 0 ? propertyDetail.Bedroom : "";
  var Bathroom =
    showBedAndBath(propertyDetail) && propertyDetail.Bathroom > 0 ? propertyDetail.Bathroom : "";

  var area = showAreaValue(propertyDetail) ? getArea(propertyDetail) : "";

  var ShowAreaValue = area ? area.value + " " + area.unit : "";
  var ShowUseableArea =
    showUseableAreaValue(propertyDetail) && propertyDetail.UseableArea
      ? propertyDetail.UseableArea.toFixed(2) + " ตร.ม."
      : "";

  return (
    <>
      <div className="detail-container">
        {ShowAreaValue && (
          <div className="detail-card">
            <p className="title">เนื้อที่</p>
            <i className="ic-npa ic-npa-icon-area"></i>
            <p className="content">{ShowAreaValue}</p>
          </div>
        )}

        {ShowUseableArea && (
          <div className="detail-card">
            <p className="title">พื้นที่ใช้สอย</p>
            <i className="ic-npa ic-npa-icon-usablearea"></i>
            <p className="content">{ShowUseableArea}</p>
          </div>
        )}

        {Bedroom && (
          <div className="detail-card">
            <p className="title">ห้องนอน</p>
            <i className="ic-npa ic-npa-icon-bedroom"></i>
            <p className="content">{Bedroom} ห้อง</p>
          </div>
        )}

        {Bathroom && (
          <div className="detail-card">
            <p className="title">ห้องน้ำ</p>
            <i className="ic-npa ic-npa-icon-bathroom"></i>
            <p className="content">{Bathroom} ห้อง</p>
          </div>
        )}

        {propertyDetail.CarParking && (
          <div className="detail-card">
            <p className="title">ที่จอดรถ</p>
            <i className="ic-npa ic-npa-icon-parking"></i>
            <p className="content">{propertyDetail.CarParking} คัน</p>
          </div>
        )}
      </div>
    </>
  );
});

export const PrivacyText = React.memo((propertyDetail) => {
  const kbankPrivacyLink = "https://kbank.co/PDPA_TH_WEBSITE";
  const JMTPrivacyLink = "https://www.j-amc.co.th/index.php/policycustomer";
  if (propertyDetail.IsPartner) {
    // var partnerName = "บริษัท บริหารสินทรัพย์ เจ จำก้ด ";
    var privacyText =
      "ข้าพเจ้ายินยอมให้ธนาคารเปิดเผยข้อมูลของข้าพเจ้าตามที่ระบุข้างต้นให้แก่ผู้ขายที่ข้าพเจ้าสนใจ (“ผู้ขาย”) และยินยอมให้ธนาคาร และ/หรือผู้ขายเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลของข้าพเจ้าดังกล่าว เพื่อวัตถุประสงค์ในการติดต่อ นำเสนอ และประชาสัมพันธ์ผลิตภัณฑ์และบริการที่ข้าพเจ้าสนใจ ข้าพเจ้าได้อ่านและเข้าใจรายละเอียดและสิทธิใน ";

    return (
      <>
        <p className="privacy-text">
          {privacyText}
          <a href={kbankPrivacyLink} target="_blank">
            นโยบายการคุ้มครองข้อมูลส่วนบุคคลของธนาคาร
          </a>{" "}
          และ นโยบายการคุ้มครองข้อมูลส่วนบุคคลของผู้ขาย ตามช่องทางที่ผู้ขายกำหนดเรียบร้อยแล้ว
        </p>
      </>
    );
  }

  return (
    <>
      <p className="privacy-text">
        ธนาคารจะเก็บรวบรวม ใช้ เปิดเผยข้อมูลส่วนบุคคลของคุณเพื่อติดต่อ
        นำเสนอและประชาสัมพันธ์ผลิตภัณฑ์และบริการที่คุณสนใจ โปรดศึกษารายละเอียดและสิทธิใน{" "}
        <a href={kbankPrivacyLink} target="_blank">
          นโยบายการคุ้มครองข้อมูลส่วนบุคคล
        </a>
      </p>
    </>
  );
});

export function getLocation(data) {
  var location = "";

  if (data.AddressNoTH) {
    location += "เลขที่ " + data.AddressNoTH;
  }

  if (data.BuildingTH) {
    location += " อาคาร " + data.BuildingTH;
  }

  if (data.FloorTH) {
    location += " ชั้น " + data.FloorTH;
  }

  if (data.VillageTH) {
    location += " หมู่บ้าน " + data.VillageTH;
  }

  if (data.SoiTH) {
    location += " ซอย " + data.SoiTH;
  }

  if (data.RoadTH) {
    location += " ถนน " + data.RoadTH;
  }

  var isBangkok = data.ProvinceName && data.ProvinceName.indexOf("กรุงเทพ") !== -1;

  if (data.TambonName) {
    location += (isBangkok ? " แขวง " : " ตำบล ") + data.TambonName;
  }

  if (data.AmphurName) {
    //location += (isBangkok ? " เขต " : " อำเภอ ") + data.AmphurName;
    if (isBangkok) {
      if (data.AmphurName.indexOf("เขต") === 0) {
        location += " " + data.AmphurName;
      } else {
        location += " เขต " + data.AmphurName;
      }
    } else {
      location += " อำเภอ " + data.AmphurName;
    }
  }

  if (data.ProvinceName) {
    location += " จังหวัด " + data.ProvinceName;
  }

  return location.trim();
}

export const TagPropertiesWrapper = React.memo((propertyDetail) => {
  const group = propertyDetail.CategoryGroup;

  const tags = group?.split("#")?.filter((tag) => tag !== "") ?? [];

  const tagToLink = (tag) => {
    switch (tag) {
      case "ทรัพย์อุ่นใจใกล้หมอ":
        return pagesLink.search+"?searchpurposes=Doctor";
      case "ทรัพย์เพื่อตากอากาศ":
        return pagesLink.search+"?searchpurposes=Bungalow";
      case "ทรัพย์ต่างจังหวัดใจกลางเมือง":
        return pagesLink.search+"?searchpurposes=CityCenter";
      case "ทรัพย์กรุงเทพฯ รอบนอก":
        return pagesLink.search+"?searchpurposes=OuterBangkok";
      case "ทรัพย์เด่นแนวรถไฟฟ้า":
        return pagesLink.search+"?searchpurposes=OutstandingAlongTheSkyTrain";
      default:
        return pagesLink.search;
    }
  };

  // Doctor ทรัพย์อุ่นใจใกล้หมอ
  // Bungalow ทรัพย์เพื่อตากอากาศ
  // CityCenter ทรัพย์ต่างจังหวัดใจกลางเมือง
  // OuterBangkok ทรัพย์กรุงเทพฯ รอบนอก
  // OutstandingAlongTheSkyTrain ทรัพย์เด่นแนวรถไฟฟ้า

  return (
    <>
      <div className="tag-properties-wrapper">
        {tags.map((tag) => (
          <a
            key={tag}
            href={tagToLink(tag)}//{pagesLink.searchTag + tag}
            className="tag-properties pxtm-click-linkClick"
            title={tag}
            data-kbct="link_click" data-kblb="tag" data-kbgp="detail_tag" data-kbsc="detail"
          >
            {tag}
          </a>
        ))}
      </div>
      {/* <div className="tag-properties-wrapper">
        <a
          href={pagesLink.searchTag + "ทรัพย์ใกล้รถไฟฟ้า"}
          className="tag-properties pxtm-click-linkClick"
          title="ทรัพย์ใกล้รถไฟฟ้า"
        >
          ทรัพย์ใกล้รถไฟฟ้า
        </a>
        <a
          href={pagesLink.searchTag + "ทรัพย์ใกล้หมอ"}
          className="tag-properties pxtm-click-linkClick"
          title="ทรัพย์ใกล้หมอ"
        >
          ทรัพย์ใกล้หมอ
        </a>
        <a
          href={pagesLink.searchTag + "ทรัพย์พร้อมอยู่"}
          className="tag-properties pxtm-click-linkClick"
          title="ทรัพย์พร้อมอยู่"
        >
          ทรัพย์พร้อมอยู่
        </a>
        <a
          href={pagesLink.searchTag + "ทรัพย์ราคาพิเศษ"}
          className="tag-properties pxtm-click-linkClick"
          title="ทรัพย์ราคาพิเศษ"
        >
          ทรัพย์ราคาพิเศษ
        </a>
      </div> */}
    </>
  );
});

export const DetailWrapper = React.memo((propertyDetail) => {
  return (
    <>
      <div className="icon-detail-wrapper">
        {propertyDetail.ShowAreaValue && (
          <div className="detail-card">
            <p className="title dt">เนื้อที่</p>
            <i className="ic-npa ic-npa-icon-area" />
            <div className="box-detail">
              <p className="title mb">เนื้อที่</p>
              <p className="content">{propertyDetail.ShowAreaValue}</p>
            </div>
          </div>
        )}
        {propertyDetail.ShowUseableArea && (
          <div className="detail-card">
            <p className="title dt">พื้นที่ใช้สอย</p>
            <i className="ic-npa ic-npa-icon-usablearea" />
            <div className="box-detail">
              <p className="title mb">พื้นที่ใช้สอย</p>
              <p className="content">{propertyDetail.ShowUseableArea}</p>
            </div>
          </div>
        )}
        {propertyDetail.Bedroom && (
          <div className="detail-card">
            <p className="title dt">ห้องนอน</p>
            <i className="ic-npa ic-npa-icon-bedroom" />
            <div className="box-detail">
              <p className="title mb">ห้องนอน</p>
              <p className="content">{propertyDetail.Bedroom} ห้อง</p>
            </div>
          </div>
        )}
        {propertyDetail.Bathroom && (
          <div className="detail-card">
            <p className="title dt">ห้องน้ำ</p>
            <i className="ic-npa ic-npa-icon-bathroom" />
            <div className="box-detail">
              <p className="title mb">ห้องน้ำ</p>
              <p className="content">{propertyDetail.Bathroom} ห้อง</p>
            </div>
          </div>
        )}
        {propertyDetail.CarParking && (
          <div className="detail-card">
            <p className="title dt">ที่จอดรถ</p>
            <i className="ic-npa ic-npa-icon-parking" />
            <div className="box-detail">
              <p className="title mb">ที่จอดรถ</p>
              <p className="content">{propertyDetail.CarParking} คัน</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
});

export const TableDetail = React.memo((propertyDetail) => {
  // console.log("render TableDetail");

  var area = showAreaValue(propertyDetail) ? getArea(propertyDetail) : "";

  area = area ? area.value + " " + area.unit : "";

  return (
    <>
      <div className="table-detail">
        <h2>รายละเอียดทรัพย์สิน</h2>
        <table>
          <tbody>
            {propertyDetail.PropertyTypeName && (
              <tr>
                <td>ประเภททรัพย์</td>
                <td>{getPropertyType(propertyDetail)}</td>
              </tr>
            )}
            {propertyDetail.AssetInfoTH && (
              <tr>
                <td>รายละเอียดทรัพย์</td>
                <td>{propertyDetail.AssetInfoTH}</td>
              </tr>
            )}
            {area && (
              <tr>
                <td>ขนาดพื้นที่</td>
                <td>{area}</td>
              </tr>
            )}
            {/* <tr>
              <td>ทรัพย์ใกล้รถไฟฟ้า</td>
              <td>สายสีชมพู, ฟ้า</td>
            </tr>
            <tr>
              <td>พร้อมอยู่</td>
              <td>รีโนเวทวันที่ 19 กพ 64</td>
            </tr> */}
          </tbody>
        </table>
      </div>
    </>
  );
});

export const ShareConent = () => {
  return (
    <>
      <div
        className="offcanvas offcanvas-bottom shared-offcanvas"
        tabIndex="-1"
        id="shared-offcanvas"
      >
        <div className="offcanvas-header">
          <h2 className="offcanvas-title">แชร์</h2>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="wrapper-input-link">
            <input
              type="text"
              defaultValue=""
              className="input-link"
              id="input-link-mobile"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="คัดลอกลิ้งค์แล้ว"
              data-bs-custom-class="custom-tooltip"
            />
            <div className="wrapper-icon-mobile">
              <i className="ic-npa ic-npa-icon-copylink copy-link-mobile ic-for-copy" />
              <i
                className="ic-npa ic-npa-icon-copiedlink copy-link-mobile ic-already-copy"
                style={{ display: "none" }}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-start">
            <a href="javascript:void(0)" onClick={tweetShare} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-twitter"
                data-kbct="click" data-kblb="x" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Twitter
            </a>
            <a href="javascript:void(0)" onClick={fbShare} className="offcanvas-card-link fab fa-facebook-f">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-facebook"
                data-kbct="click" data-kblb="facebook" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Facebook
            </a>
            <a href="javascript:void(0)" onClick={lineMSG} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-line"
                data-kbct="click" data-kblb="line" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Line
            </a>
            <a href="javascript:void(0)" onClick={mailShare} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-email"
                 data-kbct="click" data-kblb="mail" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Email
            </a>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-bottom shared-offcanvas"
        tabIndex="-1"
        id="shared-offcanvas-2"
      >
        <div className="offcanvas-header">
          <h2 className="offcanvas-title">แชร์</h2>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-toggle="offcanvas"
            data-bs-target="#other-offcanvas"
            aria-controls="offcanvasBottom"
          ></button>
        </div>
        <div className="offcanvas-body">
          <div className="d-flex justify-content-center align-items-start">
            <a href="javascript:void(0)" onClick={tweetShare} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-twitter"
                data-kbct="click" data-kblb="x" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Twitter
            </a>
            <a href="javascript:void(0)" onClick={fbShare} className="offcanvas-card-link fab fa-facebook-f">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-facebook"
                data-kbct="click" data-kblb="facebook" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Facebook
            </a>
            <a href="javascript:void(0)" onClick={lineMSG} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-line"
                data-kbct="click" data-kblb="line" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Line
            </a>
            <a href="javascript:void(0)" onClick={mailShare} className="offcanvas-card-link">
              <div className="offcanvas-card">
                <i className="ic-npa ic-npa-icon-email"
                data-kbct="click" data-kblb="mail" data-kbgp="social_share" data-kbsc="detail" ></i>
              </div>
              Email
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export const ModalDetail = (props) => {
  const propertyDetail = props.propertyDetail;
  const title = props.title ?? "รายละเอียดทรัพย์";
  const makeAnOfferClick = props.makeAnOfferClick;
  const isDecoration = props.isDecoration;

  var {
    propertyDetailURL,
    thumbnailURL,
    location,
    propertyName,
    tag,
    PromotionPrice,
    Price,
    areaHtml,
    bedRoomHtml,
    propertyTypeHtml,
    PropertyIDFormat,
    IsPartner,
  } = prepareDataForProopertyBox(propertyDetail);

  return (
    <>
      <div className="g-wrapper-col-r">
        <div className="g-modal-header dt">
          <h2>{title}</h2>
          <button type="button" className="close-gallery-modal">
            <img
              src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
              alt="close"
            />
          </button>
        </div>
        <div className="g-row-share">
          <div className="g-page">
            {/* <span className="g-current-page">1</span>
            <span>/</span>
            <span className="g-total-page">{slideImages.length}</span> */}
          </div>
          <div className="g-share">
            <i className="ic-npa ic-npa-icon-share" />
            <span>แชร์</span>
          </div>
          <div className="g-wrapper-share">
            <a
              href="javascript:void(0)"
              onClick={fbShare}
              className="d-flex justify-content-center align-items-center fab fa-facebook-f">
              <i className="ic-npa ic-icon-facebook-bold" 
              data-kbct="click" data-kblb="facebook" data-kbgp="social_share" data-kbsc={isDecoration?"decoration":"photo"} />
            </a>
            <a
              href="javascript:void(0)"
              onClick={tweetShare}
              className="d-flex justify-content-center align-items-center fab fa-twitter">
              <i className="ic-npa ic-icon-x" 
                data-kbct="click" data-kblb="x" data-kbgp="social_share" data-kbsc={isDecoration?"decoration":"photo"} 
              />
            </a>
            <a
              href="javascript:void(0)"
              onClick={lineMSG}
              className="d-flex justify-content-center align-items-center fab fa-line"
              >
              <i className="ic-npa ic-icon-line-bold" 
                data-kbct="click" data-kblb="line" data-kbgp="social_share" data-kbsc={isDecoration?"decoration":"photo"} 
              />
            </a>
            <a
              href="javascript:void(0)"
              onClick={mailShare}
              className="d-flex justify-content-center align-items-center copy-button"
              >
              <i className="ic-npa ic-icon-link" 
                data-kbct="click" data-kblb="link" data-kbgp="social_share" data-kbsc={isDecoration?"decoration":"photo"} 
              />
            </a>
          </div>
        </div>
        <div className="g-detail">
          <div>
            <div className="wrap-asset-title">
              <a href="javascript:void(0)">
                <h3 className="asset-title">{propertyName}</h3>
              </a>
            </div>
            <div className="location">
              <i className="ic-npa ic-npa-icon-pin" />
              <p>{location}</p>
            </div>
            <div className="wrap-address">
              <p className="asset-address">{propertyTypeHtml}</p>
              <p className="asset-code">รหัส {propertyDetail.PropertyIDFormat}</p>
            </div>
            <div className="wrap-detail">
              <div className="asset-room">{bedRoomHtml}</div>
              <div className="asset-area">{areaHtml}</div>
            </div>
            <div className="wrap-price">
              {tag}
              <div className="price">
                {PromotionPrice}
                {Price}
              </div>
            </div>
            {/* <PriceWrapper {...propertyDetail} /> */}
            <div className="mobile-contact-wrapper">
              <a
                href="javascript:void(0)"
                className="btn-green popup-goto-contact show-w1024"
                title="ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง"
                data-kbct="open_popup" data-kblb="contact_staff" data-kbgp="appointment" data-kbsc={isDecoration?"decoration":"photo"} data-kbid={propertyDetail.PropertyID} 
              >
                ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง
              </a>
              <button
                className="btn-main btn-first hide-w1024"
                data-bs-toggle="offcanvas"
                data-bs-target="#contact-offcanvas"
                aria-controls="contact-offcanvas"
                title="ติดต่อเจ้าหน้าที่/นัดหมายชมทรัพย์จริง"
                data-kbct="open_popup" data-kblb="contact_staff" data-kbgp="appointment" data-kbsc={isDecoration?"decoration":"photo"} data-kbid={propertyDetail.PropertyID} 
              >
                ติดต่อเจ้าหน้าที่/นัดหมายเข้าชมทรัพย์
              </button>
              <a
                href="javascript:void(0)"
                onClick={makeAnOfferClick}
                className="btn-white"
                title="เสนอราคาซื้อ_เอสเปช เกษตร - นวมินทร์"
                data-kbct="link_click" data-kblb="offer" data-kbgp="appointment" data-kbsc={isDecoration?"decoration":"photo"} data-kbid={propertyDetail.PropertyID}
              >
                เสนอราคาซื้อ
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
